<template>
  <div class="partner">
    <h3 class="text-center">诚挚邀请</h3>
    <ul class="text-center">
      <li class="clear">
        <div class="desc">
          <h3>生态合作伙伴</h3>
          <p>
            如果您有成熟的企业生态服务产品，可将您的产品集成在X联网中为更多的客户提供服务
          </p>
          <van-button
            type="info"
            @click="
              show = true
              title = '加入服务商合作伙伴'
              systemId = '4'
            "
          >
            立即加入
          </van-button>
        </div>
      </li>
      <li class="clear">
        <div class="desc">
          <h3>推广合作伙伴</h3>
          <p>
            如果您对我们感兴趣并拥有丰富人脉资源，可与我们一起共同推广X联网解决方案
          </p>
          <van-button
            type="info"
            @click="
              show = true
              title = '加入推广合作伙伴'
              systemId = '5'
            "
          >
            立即加入
          </van-button>
        </div>
      </li>
    </ul>
    <div class="line"></div>
    <Dialog
      :show="show"
      :systemId="systemId"
      :title="title"
      @close="show = false"
    />
  </div>
</template>
<script>
import Dialog from './components/dialog'
export default {
  components: { Dialog: Dialog },
  data() {
    return {
      systemId: '4',
      show: false,
      title: '',
    }
  },
  mounted() {},

  methods: {},
}
</script>

<style lang="scss">
.partner {
  background-color: $bg-color;
  padding: 0 0.54rem 0.3rem;
  color: #fff;
  .line {
    background-color: #434548;
  }
  h3 {
    margin: 0;
    font-size: 0.36rem;
    line-height: 1.26rem;
    font-weight: normal;
  }
  li {
    width: 6.4rem;
    height: 3.2rem;
    margin-bottom: 0.5rem;
    background: url(~@/assets/mob/images/partner_01.png);
    background-size: cover;
    &:nth-child(2) {
      background: url(~@/assets/mob/images/partner_02.png);
      background-size: contain;
    }
    .desc {
      padding: 0.3rem 0.8rem;
      h3 {
        line-height: 0.84rem;
      }
      p {
        line-height: 0.35rem;
        font-size: 0.2rem;
        margin: 0 0 0.3rem;
      }
      .van-button {
        height: 0.64rem;
        line-height: 0.64rem;
      }
    }
  }
}
</style>
